__turbopack_context__.v({
  "backgroundImage": "m4U8EG_backgroundImage",
  "heroContainer": "m4U8EG_heroContainer",
  "heroContentContainer": "m4U8EG_heroContentContainer",
  "heroDescription": "m4U8EG_heroDescription",
  "heroTitle": "m4U8EG_heroTitle",
  "logoImage": "m4U8EG_logoImage",
  "wrapper": "m4U8EG_wrapper",
});
